import cn from "classnames";
import { ColumnSizeProps } from "@fdoh/health-react";

export const strip = (query: string): string => {
  return query.replace(/[^A-Za-z0-9]/g, "").toLocaleLowerCase();
};

export const useGroupProps = <T extends ColumnSizeProps>(props: T) => {
  const { col, sm, md, lg, xl, ...rest } = props;
  const output: string = cn({
    [`col-${col}`]: col,
    [`col-sm-${sm}`]: sm,
    [`col-md-${md}`]: md,
    [`col-lg-${lg}`]: lg,
    [`col-xl-${xl}`]: xl,
  });

  return { className: output, ...rest };
};
